import { Component, computed, inject, input } from '@angular/core';
import {
  CoreJssProxyModule,
  TextField,
  type RichTextField,
} from '@core/jss-proxy';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { FieldService } from '@core/jss-utils';

import { LinkListComponent, ListLink } from '../link-list/link-list.component';

export type LinkList = {
  id: string;
  title: TextField;
  links: ListLink[];
};

@Component({
  selector: 'wl-link-list-section',
  standalone: true,
  templateUrl: './link-list-section.component.html',
  styleUrls: [
    './link-list-section.component.ed.scss',
    './link-list-section.component.essent.scss',
  ],
  imports: [CoreJssProxyModule, LinkListComponent, RichTextWrapperComponent],
})
export class LinkListSectionComponent {
  readonly title = input.required<TextField>();
  readonly introduction = input.required<RichTextField>();
  readonly linkLists = input.required<LinkList[]>();

  readonly #fieldService = inject(FieldService);

  readonly showIntroduction = computed(() =>
    this.#fieldService.showTextField(this.introduction())
  );
}
